import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import { Map as ImmutableMap } from 'immutable';
import { createAction } from 'redux-actions';

export const DIALOG_TYPE = 'DELETE_REMINDER_DIALOG';

export const showDeleteReminderDialog = createAction(rootUiActions.createDialog.toString(), (txn, wrapperId = '') =>
  rootUiTypes.mkRootUiData({
    id: DIALOG_TYPE,
    type: DIALOG_TYPE,
    allowNesting: true,
    props: ImmutableMap({
      txn,
      wrapperId,
    }),
  }),
);
